// extracted by mini-css-extract-plugin
module.exports = {"flexEnd":"style__flexEnd__0+jdY","customSample":"style__customSample__upiq0","removeIcon":"style__removeIcon__xnrnm","tinyCol":"style__tinyCol__6F48X"};